import { useCallback, useEffect } from "react";
import { throttle } from "lodash";

/**
 *
 * @param {Function} callback The callback to memoize
 * @param {array} dependencies The callback depencies passed to useCallback
 * @param {number} wait The lodash's throttle function wait parameter
 * @param {import("lodash").ThrottleSettings} options
 * @returns the memoized and throttled function
 */
export const useThrottledCallback = (callback, dependencies, wait, options) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const throttledCallback = useCallback(throttle(callback, wait, options), dependencies);

  // When the component is unmounted or the callback is changed, ensure there's no
  // trailing callback call that's going to happen, which would possibly lead to
  // unmounted component state change, or stale closure variables use.
  useEffect(() => () => throttledCallback?.cancel(), [throttledCallback]);

  return throttledCallback;
};
